/* eslint-disable */
import { transformBannerResponseToBannerListItem } from "./transform";

export class ArticleUseCase {
  /**
   *
   * @param {import('../../clients/BaanRueJaiClient').BaanRueJaiClient} client
   */
  constructor(client) {
    this.client = client;
  }

  /**
   * @async
   * @return {import('./models/BannerListItem').BannerListItem[]}
   */
  async listBanner(params) {
    const { data } = await this.client.admin.banner.list(params);

    const pinnedResponse = await this.client.admin.articles.getPin('PINNED_ARTICLE_BANNER');

    let pinnedBanners = []
    if (pinnedResponse.data.result !== null) {
      pinnedBanners = pinnedResponse.data.result.map((item) => item.article_id);
    }

    return {
      articleBanners: data.result.article_banners.map((item) =>
        transformBannerResponseToBannerListItem(item, pinnedBanners)
      ),
      count: data.result.count
    };
  }

  /**
   * @async
   * @param {string} id
   *
   * @return {void}
   */
  async deleteBanner(id) {
    await this.client.admin.banner.delete(id);
  }
}



// WEBPACK FOOTER //
// ./src/features/articles/ArticleUseCase.js